import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Prioridade } from '../pages/domain/domain.model';

@Injectable({providedIn: 'root'})
export class PrioridadeService {

    constructor(private http: HttpClient, private account: AccountService) { }


    getAll(): Observable<Prioridade[]> {

        return this.http.get<Prioridade[]>(`${SCAMP_API.accountApiV1}/prioridades`, { headers: this.account.composeHeaders() });
    }
   

    getById(id: number): Observable<Prioridade> {
        return this.http.get<Prioridade>(`${SCAMP_API.accountApiV1}/prioridades/${id}`,
            { headers: this.account.composeHeaders() });
    }

    isUnique(descricao: string): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/prioridades/descricao/isunique`, {descricao},
            { headers: this.account.composeHeaders() });
    }

    post(data: Prioridade) {
        return this.http.post(`${SCAMP_API.accountApiV1}/prioridades`, data,
            { headers: this.account.composeHeaders() });
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/prioridades/${id}`,
            { headers: this.account.composeHeaders() });
    }

}
